import React, {Component} from 'react';

import {Button, Col, Row} from "reactstrap";
import GeneralUtils from "../../utils/GeneralUtils";
import Translate from "../../language/Translate";
import {Dialog} from "primereact/dialog";
import {AvForm} from 'availity-reactstrap-validation';
import {
    getMemberCookiePolicyBodyHtml,
    getMemberPrivacyPolicyBodyHtml,
    getMemberTermsAndConditionsBodyHtml
} from "./MemberLegalHtml";


export class AppFooterMember extends Component {
    constructor() {
        super();
        this.state = {
            openTermsDialog: false,
            openPrivacyDialog: false,
            openCookieDialog: false
        };
    }

    componentDidMount = () => {

    }

    /** Desktop: compact zoom. Narrow viewport: rely on App.css tap-target rules (UA-only isMobile misses DevTools). */
    linkStyle = () => {
        if (typeof window !== 'undefined' && window.innerWidth <= 767) {
            return {};
        }
        return {zoom: 0.7};
    };

    renderHtmlBlock(htmlGetter) {
        return (
            <div dangerouslySetInnerHTML={{__html: htmlGetter()}}/>
        );
    }

    render() {
        return (
            <AvForm>
                <footer className="footerMember">
                    <div className="p-col-12" style={{display: 'block', padding: 15, textAlign: 'center'}}>
                        {!GeneralUtils.isMobile() &&
                            <Row>
                                <Col md={12}>
                                    {this.renderLegalFooterLinks()}
                                </Col>
                            </Row>
                        }

                        {GeneralUtils.isMobile() &&
                            <Row>
                                <Col md={12}>
                                    {this.renderLegalFooterLinks()}
                                </Col>

                            </Row>
                        }
                    </div>
                    {GeneralUtils.isMobile() &&
                        <div>
                            <br></br>
                            <br></br>
                        </div>
                    }
                </footer>
            </AvForm>

        );
    }


    renderLegalFooterLinks() {
        const s = this.linkStyle();
        const sep = <span aria-hidden="true"> · </span>;
        return (
            <div>
                <nav aria-label="Legal information" style={{display: 'inline'}}>
                    <a
                        href="javascript:void(0);"
                        onClick={() => this.setState({openTermsDialog: true})}
                        style={s}
                    >
                        Terms &amp; Conditions
                    </a>
                    {sep}
                    <a
                        href="javascript:void(0);"
                        onClick={() => this.setState({openPrivacyDialog: true})}
                        style={s}
                    >
                        Privacy Policy
                    </a>
                    {sep}
                    <a
                        href="javascript:void(0);"
                        onClick={() => this.setState({openCookieDialog: true})}
                        style={s}
                    >
                        Cookie Policy
                    </a>
                </nav>

                <Dialog header="Terms & Conditions"
                        visible={this.state.openTermsDialog}
                        style={GeneralUtils.getDialogStyleForDialog()}
                        onHide={() => this.setState({openTermsDialog: false})}>

                    <p style={{textAlign: "left"}}>
                        {this.renderHtmlBlock(getMemberTermsAndConditionsBodyHtml)}
                    </p>

                    <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}}
                            onClick={() => this.setState({openTermsDialog: false})}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>

                </Dialog>

                <Dialog header="Privacy Policy"
                        visible={this.state.openPrivacyDialog}
                        style={GeneralUtils.getDialogStyleForDialog()}
                        onHide={() => this.setState({openPrivacyDialog: false})}>

                    <p style={{textAlign: "left"}}>
                        {this.renderHtmlBlock(getMemberPrivacyPolicyBodyHtml)}
                    </p>

                    <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}}
                            onClick={() => this.setState({openPrivacyDialog: false})}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>

                </Dialog>

                <Dialog header="Cookie Policy"
                        visible={this.state.openCookieDialog}
                        style={GeneralUtils.getDialogStyleForDialog()}
                        onHide={() => this.setState({openCookieDialog: false})}>

                    <p style={{textAlign: "left"}}>
                        {this.renderHtmlBlock(getMemberCookiePolicyBodyHtml)}
                    </p>

                    <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}}
                            onClick={() => this.setState({openCookieDialog: false})}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>

                </Dialog>
            </div>
        );
    }
}
